import { ReactNode } from 'react';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { Entitlement } from '@dxb-web-ui-framework/iam/domain/AccessControl/entities/Entitlement';
import { UserInfo } from '../../domain/UserInfo/entities';
import { Customer } from '../../domain/UserInfo/entities';

export interface UserInfoProviderState {
  userInfo: Nullable<UserInfo>;
  customerList: Nullable<Customer[]>;
  entitlements: Entitlement[];
  selectedCustomerId: Nullable<string>;
  onSelectCustomerId(id: string): void;
  refetchDashboardData?: Function;
  loadingState: {
    isLoadingEntitlementsData: boolean;
  };
}

export type UserInfoProviderProviderProps = {
  entitlements: Entitlement[];
  loaderComponent?: ReactNode;
  errorComponent?: ReactNode;
};

export enum UserProfileActionTypes {
  setSelectedCustomerId = '@@UserProfile/setSelectedCustomerId',
  setEntitlement = '@@UserProfile/setEntitlement',
}
